import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);
export function common() {

  // headerScroll();
document.addEventListener('DOMContentLoaded', function () {
        gsap.config({ nullTargetWarn: false })

        // Set initial opacity of the scroll top button to 0
        const scrollTopButton = document.getElementById("js-scrollTop");
        gsap.set(scrollTopButton, { autoAlpha: 0 });

        // フッター TOPスクロールボタン
        window.addEventListener("scroll", () => {
            const scrollTopButton = document.getElementById("js-scrollTop");
            const isScrollingDown = window.scrollY > 400;

            if ((isScrollingDown && gsap.getProperty(scrollTopButton, "opacity") === 0) ||
                (!isScrollingDown && gsap.getProperty(scrollTopButton, "opacity") === 1)) {
                gsap.to(scrollTopButton, {
                    duration: 1,
                    autoAlpha: isScrollingDown ? 1 : 0,
                    ease: isScrollingDown ? "power3.out" : "power3.in",
                });
            }
        });

        document.getElementById("js-scrollTop").addEventListener("click", () => {
            gsap.to(window, {
                duration: 1,
                scrollTo: {
                    y: 0,
                    autoKill: false,
                },
            });
        });
});
}
